import { createAsyncThunk, createSlice, isFulfilled, isRejected } from '@reduxjs/toolkit';
import { API_PING, WHOAMI } from '../settings';
import { fetchData, getCurrentAppVersion, isNone } from '../utils';
import { setNotification } from './notificationsSlice';
import { schemas } from './schemas';
import { updateUserVersion } from './api/users';

export const getCurrentUser = createAsyncThunk(
    "getCurrentUser",
    async (arg, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(WHOAMI, {}, schemas.CURRENT_USER);
            return Object.values(response.entities.users)[0] || { fullName: "Unknown User" }
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue({ code: e.code });
        }
    },
    {
        condition: (arg, { getState }) => {
            const { user } = getState();
            return user.requesting;
        }
    }
);

export const pingServer = createAsyncThunk(
    "pingServer",
    async (arg, { dispatch }) => {
        try {
            fetchData(API_PING, {}, {});
        } catch (e) {
            dispatch(setNotification(e));
        }
    }
)

const initialState = {
    grants: {},
    requesting: true,
    version: null
};

const user = createSlice({
    name: "user",
    initialState,
    reducers: {
        resetVersion: (state) => {
            state.version = null;
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(getCurrentUser.pending, (state) => {
            state.requesting = false;
        })
        .addCase(getCurrentUser.fulfilled, (state, { payload }) => {
            state.grants = payload;
            state.requesting = true;
        })
        .addCase(getCurrentUser.rejected, () => {
            return initialState;
        })
        .addCase(updateUserVersion.fulfilled, (state, { payload }) => {
            if (payload !== undefined) {
                state.grants.lastSeenVersion = payload;
            };
        })
        .addMatcher(action => isFulfilled(action) || isRejected(action), (state) => {
            let newVersion = window.localStorage.getItem("version");
            if (!isNone(newVersion) && newVersion != getCurrentAppVersion()) {
                state.version = newVersion;
            }
        })
    }
});

export const { resetVersion } = user.actions;
export default user.reducer;